import {Injectable} from '@angular/core';

/*
  Generated class for the DateTimeProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class DateTimeProvider {

  /**
   * Retrieve the date in ISO formated string with time zone.
   * Output Example: 2018-04-22T12:21:47-03:00
   *
   * @param date Date to be parsed.
   * @returns ISO formated string with time zone.
   */
  public getISOString(date: Date = null) {
    if (date === null) {
      date = new Date();
    }

    let tzo = -date.getTimezoneOffset();
    let dif = (tzo >= 0) ? '+' : '-';

    let pad = function (num) {
      var norm = Math.floor(Math.abs(num));

      return ((norm < 10) ? '0' : '') + norm;
    };

    let output = '';
    output += date.getFullYear();
    output += '-' + pad(date.getMonth() + 1);
    output += '-' + pad(date.getDate());
    output += 'T' + pad(date.getHours());
    output += ':' + pad(date.getMinutes());
    output += ':' + pad(date.getSeconds());
    output += dif + pad(tzo / 60);
    output += ':' + pad(tzo % 60);

    return output;
  }

  /**
   * Retrieve the date as string.
   *
   * @param date Date to be parsed.
   * @returns Date as string.
   */
  public getString(date: Date = null) {
    if (date === null) {
      date = new Date();
    }

    return (date.getTime()).toString();
  }

}



// WEBPACK FOOTER //
// ./src/providers/datetime/datetime.ts